var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgImg"},[_c('img',{staticClass:"loginLogo",attrs:{"src":require("../../assets/common/logo02.jpg")}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"loginBtn"},[_vm._v(_vm._s(_vm.loginBtnText))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6afb115e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/auto-login.vue
// module id = null
// module chunks = 